import { normalizePlatformSiteMarkers } from '../../utils/platformSiteMarkers';
import { PlatformSiteMarkersFormValues } from './PlatformSiteMarkersForm';

export function toPlatformSiteMarkersFormValues(
  markers?: string[] | null,
): PlatformSiteMarkersFormValues {
  return {
    hosts: [...(markers ?? [])],
  };
}

export function formatPlatformSiteMarkersLabel(markers?: string[] | null): string {
  const list = (markers ?? []).map(marker => marker.trim()).filter(Boolean);
  if (list.length === 0) {
    return 'No websites listed yet';
  }
  return list.join(', ');
}

export function buildUpdatePlatformSiteMarkersInput(
  values: PlatformSiteMarkersFormValues,
): { hosts: string[] } | { error: string } {
  const hosts = normalizePlatformSiteMarkers(values.hosts);
  if (hosts.length === 0) {
    return { error: 'Add at least one platform site marker.' };
  }
  return { hosts };
}

// Pure whitelist helpers live in their own module so the form (and its test)
// do not pull in the Apollo client through this file's imports.
export {
  normalizeRedirectWhitelistMarker,
  addRedirectWhitelistUrl,
  removeRedirectWhitelistUrl,
} from './redirectWhitelist';
